
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import NecList from './nec-list';
import NecForms from './nec-forms';
import { paths } from '../../../routes';

const Nec = () => (
  <Switch>
    <Route path={paths.proprete.path} exact>
      <NecList />
    </Route>
    <Route path={paths.newProprete.path}>
      <NecForms />
    </Route>
    <Route path={paths.proprete.path + '/:reportId'}>
      <NecForms />
    </Route>
  </Switch>
);

export default Nec;
